/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalResponse
 */
export interface PortalResponse {
    /**
     * 
     * @type {string}
     * @memberof PortalResponse
     */
    url: string;
}

export function PortalResponseFromJSON(json: any): PortalResponse {
    return PortalResponseFromJSONTyped(json, false);
}

export function PortalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function PortalResponseToJSON(value?: PortalResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

